(function () {
  'use strict';

  const angular = window.angular;

  LoginController.$inject = ['AuthService', '$state', 'AppUtils'];

  angular.module('app').component('publicLogin', {
    template:'<section class="login-container"><div class="login-header"><div class="login-brand"></div><h3 class="no-margin" translate>buttons.signin</h3></div><div ng-if="!$ctrl.show2fa"><form class="login-form login-content validate" name="$ctrl.loginForm" novalidate ng-submit="$ctrl.login()"><div class="form-group" show-errors><div class="input-group"><span class="input-group-addon"><i class="fas fa-user fa-fw"></i></span> <input ng-model="$ctrl.username" class="form-control" name="username" required maxlength="254" pattern="^(?:[A-Za-z][A-Za-z.\\d_\\-]*[A-Za-z\\d]{2,64}|[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,6})$" translate-attr="::{placeholder: \'entities._all.username\'}"></div><p ng-messages="$ctrl.loginForm.username.$error" class="help-block" role="alert"><span ng-message="required" translate>form.errors.required</span></p></div><div class="form-group" show-errors><div class="input-group"><span class="input-group-addon"><i class="fas fa-key fa-fw"></i></span> <input ng-model="$ctrl.password" type="password" class="form-control" name="password" required maxlength="150" translate-attr="::{placeholder: \'entities._all.password\'}"></div><p ng-messages="$ctrl.loginForm.password.$error" class="help-block" role="alert"><span ng-message="required" translate>form.errors.required</span></p></div><div class="checkbox marginB20"><label><input ng-model="$ctrl.rememberMe" type="checkbox"> <span translate>views.public.rememberMe</span></label></div><button class="btn btn-login btn-lg btn-block" ng-disabled="$ctrl.loginError === \'LOGIN_COOLDOWN\'" translate>buttons.signin</button><div class="text-center marginT20"><a ui-sref="public.resetPassword" translate>views.public.forgotPassword</a></div><div ng-if="$ctrl.loginError" class="alert alert-danger marginT20 marginB0 padding5 text-center">{{\'errors.\' + $ctrl.loginError | translate}}</div><div ng-if="$ctrl.activeDirectoryEnabled"><hr><button class="btn btn-login btn-sso btn-add btn-lg btn-block text-left" ng-click="$ctrl.loginWithAd()"><i class="fab fa-microsoft btn-icon"></i><span translate>buttons.signinADD</span></button></div></form></div><div ng-if="$ctrl.show2fa"><form class="login-form login-content validate" name="$ctrl.twoFactorForm" novalidate ng-submit="$ctrl.validate2faAndLogin()"><div class="form-group" show-errors><div class="input-group"><span class="input-group-addon"><i class="fas fa-lock fa-fw"></i></span> <input ng-model="$ctrl.twoFactorCode" class="form-control" name="codef2a" placeholder="{{ \'form.2fa.verificationCode\' | translate }}"></div><p ng-messages="$ctrl.twoFactorForm.code.$error" class="help-block" role="alert"><span ng-message="required" translate>form.errors.required</span></p></div><button class="btn btn-login btn-lg btn-block" ng-disabled="!$ctrl.twoFactorCode">Validar 2FA</button><div class="text-center marginT20"><div ng-if="!$ctrl.show2faMissingMessage"><a style="cursor: pointer" ng-click="$ctrl.showMissingPhoneMessage()" translate>form.2fa.missingPhoneButton</a></div><div ng-if="$ctrl.show2faMissingMessage"><span translate>form.2fa.managerMissingPhoneMessage</span></div><div><a style="cursor: pointer" ng-click="$ctrl.back2Login()" translate>buttons.back</a></div></div><div ng-if="$ctrl.loginError" class="alert alert-danger marginT20 marginB0 padding5 text-center">{{\'errors.\' + $ctrl.loginError | translate}}</div></form></div></section>',
    controller: LoginController,
  });

  function LoginController(AuthService, $state, utils) {
    let vm = this;

    this.$onInit = function () {
      vm.login = login;
      vm.rememberMe = true;
      vm.show2fa = false;
      vm.activeDirectoryEnabled = window.activeDirectoryEnabled;
      vm.show2faMissingMessage = false;
      vm.validate2faAndLogin = validate2faAndLogin;
      vm.showMissingPhoneMessage = showMissingPhoneMessage;
      vm.back2Login = back2Login;
      vm.loginWithAd = loginWithAd;
    };

    function showMissingPhoneMessage() {
      vm.show2faMissingMessage = true;
    }
    function back2Login() {
      vm.show2fa = false;
      vm.show2faMissingMessage = false;
    }

    function validate2faAndLogin() {
      vm.userData.token = vm.twoFactorCode;
      return AuthService.login2fa(vm.userData)
        .then(goAfterLogin)
        .catch((err) => {
          const error = utils.getLoginError(err);
          vm.loginError = error.code || error.message;
        });
    }

    function login() {
      if (!vm.loginForm.$valid) {
        return;
      }
      let username = vm.username.trim();
      let password = vm.password.trim();
      let rememberMe = vm.rememberMe;

      AuthService.login(username, password, rememberMe)
        .then(function (res) {
          if (res.code === 'OTP_REQUIRED') {
            vm.show2fa = true;
            vm.userData = {
              username: username,
              password: password,
              rememberMe: rememberMe,
            };
          } else {
            return goAfterLogin(res);
          }
        })
        .catch(function (err) {
          const error = utils.getLoginError(err);
          vm.loginError = error.code || error.message;
          if (vm.loginError === 'LOGIN_FAILED_EMAIL_NOT_VERIFIED') {
            $state.go('public.validateEmail');
          }
          console.log(vm.loginError);
        });
    }

    function goAfterLogin(accessToken) {
      const state = utils.tokenHasScope(accessToken, 'reset-password')
        ? 'forcePasswordChange'
        : 'member.home';
      return $state.go(state);
    }

    function loginWithAd() {
      if (!vm.activeDirectoryEnabled) {
        return;
      }

      window.location.href = window.apiPath + '/active-directory/login';
    }
  }
})();
